<template>
  <div>
    <v-autocomplete
      :selected.sync="selected"
      :items="items"
      :value='value'
      chips
      small-chips
      :item-text='itemText || "name"'
      :item-value="itemValue || 'id'"
      :label="label"
      :rules="rules"
      @input='inputValue'
      @change='changeValue'
      @click:clear='selected === ""'
      v-bind="$attrs"
      deletable-chips
      clear-icon="mdi-close-circle-outline"
    >
    <template v-slot:prepend-item>
      <slot name='prepend-item'></slot>
    </template>
    <template v-slot:selection="{ item, index }">
        <span  v-if="index === 0">{{ item.name || item[itemText]}} <span v-if="item.createDay">({{item.createDay | formatDay}}创建)</span></span>
        <!-- <v-chip small v-if="index === 0" color='primary' label class="ml-0">
          <span  v-if="index === 0">{{ item.name || item[itemText]}}</span>
        </v-chip> -->
        <span
          v-if="index === 1"
          class="grey--text text-caption"
        >
          (+{{ value.length - 1 }})
        </span>
      </template>
    </v-autocomplete>
  </div>
</template>
<script>
import { list } from '@/api/data.js'

export default {
  props: {
    value: {
      type: [Number, String, Object, Array],
      required: false
    },
    path: {
      type: String,
      required: false
    },
    itemText: {
      type: String,
      required: ''
    },
    itemValue: {
      type: String,
      required: ''
    },
    param: {
      type: Object,
      default: () => ({})
    },
    label: {
      type: String,
      required: true
    },
    rules: {
      type: Array,
      default: () => ([])
    },
    data: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      loading: false,
      items: [],
      selected: ''
    }
  },
  methods: {
    loadData () {
      if (this.path) {
        this.loading = true
        list(this.path, {}).then(res => {
          if (res.status === 200) {
            this.items = res.data
          }
          this.loading = false
        })
      } else {
        this.items = this.data
      }
    },
    changeValue (val) {
      this.$emit('on-change', val)
    },
    inputValue (obj) {
      this.$emit('input', obj)
    }
  },
  created() {
    this.loadData()
  }
}
</script>
<style scoped>
</style>
